import { generateMdx } from '../lib/markdown';
import type { WidgetProps } from './types';

// A heading and text of the workspace's own.
export default function Markdown({ config }: WidgetProps<{ title?: string; text?: string }>) {
  if (!config.text && !config.title) return null;
  return (
    <section className="border border-softgrey rounded-xl bg-white p-4">
      {config.title && <h4 className="text-sm font-semibold text-graphite mb-2">{config.title}</h4>}
      {config.text && (
        <div className="text-sm text-coolslate" dangerouslySetInnerHTML={{ __html: generateMdx(config.text) }} />
      )}
    </section>
  );
}
